module.exports = __webpack_public_path__ + "static/media/Kognitiva teamet uses Curoflow telemedicine platform.d08b62f9.webp";